<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>首页</el-breadcrumb-item>
			  <el-breadcrumb-item>邀请人列表</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button" @click="fanhui" style="cursor:pointer;">
				<i class="el-icon-arrow-left"></i>
				<p>返回</p>
			</div>
		</div>
		<YqList :list="list" :d_id="d_id"></YqList>
		<div class="fenye" v-if="total>12">
		   <el-pagination
			 background
			 @current-change="handleCurrentChange"
			 :current-page.sync="currentPage1"
			 :page-size="12"
			 layout="total, prev, pager, next ,jumper"
			 :total="total">
		   </el-pagination>
		</div>
	</div>
</template>
<script>
	import {UserCooperate} from "@/api/api.js"
	import YqList from '@/common/YqList.vue';
	export default {
	  name: 'HelloWorld',
	  components:{
		YqList  
	  },
	  data() {
	    return {
		    nametype:[
				{name:"承认图"},
				{name:"生产图"}
			],
			typeindex:0,
			currentPage1:1,
			page:1,
			total:0,
			datails:"",
			pagecount:0,
			list:[],
	    }
	  },
	  watch: {
	    // 从子页（详情/邀请）返回时刷新列表
	    '$route'(to) {
	        this.getUserCooperate()
	    }
	  },
	  computed: {
	    d_id() {
	      return this.$route.query.d_id || ''
	    }
	  },
	  mounted() {
	     this.getUserCooperate()
	  },
	  methods: {
		  fanhui(){
		  			 this.$router.go(-1);   
		  },
		getUserCooperate(){
		   UserCooperate({
			   page:this.page,
			   limit:'12'
		   }).then(res=>{
			   const data = (res && res.data && res.data.data) || {}
			   this.total = Number(data.total) || 0
			   this.datails = data
			   this.pagecount = Number(data.pass_count) || 0
			   this.currentPage1 = Number(data.current_page) || 1
			   this.list = Array.isArray(data.data) ? data.data : []
		   })
		},
		handleCurrentChange(e){
			this.page=e
			this.getUserCooperate()
		},
		qiehuan(index){
			this.typeindex=index
		}
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.fenye{
		width:100%;
		display:flex;
		align-items: center;
		justify-content: center;
		padding-bottom:20px;
	}
</style>